import React from 'react'

const SearchRawCount = React.memo(({ count }) => {
  return count > 0 ? count : ''
})

export default SearchRawCount
